import http from "@/http/aisea/axios";

const resource = "/plot";

export default {

  // 検索
  search(plotChildCategoryIds,
         northEastLatitude,
         northEastLongitude,
         southWestLatitude,
         southWestLongitude) {
    return http.get(`${resource}`, {
      params: {
        plot_child_category_id: plotChildCategoryIds,
        north_east_latitude: northEastLatitude,
        north_east_longitude: northEastLongitude,
        south_west_latitude: southWestLatitude,
        south_west_longitude: southWestLongitude
      }
    });
  },

  searchByGeoJson(plotChildCategoryIds,
          northEastLatitude,
          northEastLongitude,
          southWestLatitude,
          southWestLongitude) {
    return http.get(`${resource}/geojson`, {
      params: {
        plot_child_category_id: plotChildCategoryIds,
        north_east_latitude: northEastLatitude,
        north_east_longitude: northEastLongitude,
        south_west_latitude: southWestLatitude,
        south_west_longitude: southWestLongitude
      }
    });
  },

  get(id) {
    return http.get(`${resource}/${id}`);
  },

  // 登録
  add(request) {
    return http.post(`${resource}`, request);
  },

  // 更新
  update(request) {
    return http.put(`${resource}`, request);
  },

  // 削除
  delete(id) {
    return http.delete(`${resource}/${id}`);
  },

};
